const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3187/api';

class ApiService {
  async checkAuth() {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/status`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        return { authenticated: false };
      }

      return await response.json();
    } catch (error) {
      console.error('Error checking auth status:', error);
      return { authenticated: false };
    }
  }

  getLoginUrl() {
    return `${API_BASE_URL}/auth/login`;
  }

  getLogoutUrl() {
    return `${API_BASE_URL}/auth/logout`;
  }

  async logout() {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return await response.json();
    } catch (error) {
      console.error('Error during logout:', error);
      throw error;
    }
  }

  async searchLocation(query) {
    try {
      const response = await fetch(`${API_BASE_URL}/search?q=${encodeURIComponent(query)}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 401) {
        window.location.href = this.getLoginUrl();
        throw new Error('Unauthorized - redirecting to login');
      }

      if (!response.ok) {
        throw new Error(`Search failed: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error searching location:', error);
      throw error;
    }
  }

  async getGeoJsonLayers() {
    try {
      const response = await fetch(`${API_BASE_URL}/layers`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 401) {
        window.location.href = this.getLoginUrl();
        throw new Error('Unauthorized - redirecting to login');
      }

      if (!response.ok) {
        throw new Error(`Failed to fetch layers: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching GeoJSON layers:', error);
      throw error;
    }
  }

  async getGeoJsonLayer(layerName) {
    try {
      const response = await fetch(`${API_BASE_URL}/layers/${encodeURIComponent(layerName)}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 401) {
        window.location.href = this.getLoginUrl();
        throw new Error('Unauthorized - redirecting to login');
      }

      if (!response.ok) {
        throw new Error(`Failed to fetch layer ${layerName}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Error fetching GeoJSON layer ${layerName}:`, error);
      throw error;
    }
  }

  async createDoctor(doctorData) {
    try {
      const response = await fetch(`${API_BASE_URL}/doctors`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(doctorData),
      });

      if (response.status === 401) {
        window.location.href = this.getLoginUrl();
        throw new Error('Unauthorized - redirecting to login');
      }

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to create doctor: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating doctor:', error);
      throw error;
    }
  }
}

const apiService = new ApiService();
export default apiService;
